const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/plan/$planId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
import { isHttpError } from '@/lib/utils/common/isHttpError';
const paramsSchema = z.object({
  planId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/plan/$planId')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      planId,
      loopId,
      org
    }
  }) => {
    try {
      const plan = await queryClient.ensureQueryData(getPlanQueryOptions({
        planId
      }));
      if (plan.loopId !== loopId) {
        throw redirect({
          to: '/org/$org/loop/$loopId/plan',
          params: {
            org,
            loopId
          }
        });
      }
      return {
        plan
      };
    } catch (error) {
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org/loop/$loopId/plan',
          params: {
            org,
            loopId
          }
        });
      }
      throw error;
    }
  }
});